import { useState } from "react"
import AuthCode from 'react-auth-code-input'
import styles from './RecoverCode.module.scss'
import eye from 'assets/icons/eye.png'
import hidden from 'assets/icons/hidden.png'
const RecoverCode = ({ setRecoverCode, passwordVisible }) => {

  
  const [isError, setIsError] = useState(false);
  const handleOnChange = (value) => {
    setIsError(value.length < 6);
    if (value.length == 6){
      setRecoverCode(value)
  }
    
  };
  return (
    <>
    
      <AuthCode
              length={6}
              onChange={handleOnChange}
              allowedCharacters={'numeric'}
              containerClassName={styles.container}
              required
              inputClassName={isError ? `${styles.inputs} ${styles.error}` : styles.inputs}
              autoComplete="off new-password"
             
            />
  
  </>
  )
}
export default RecoverCode
